import { TweenMax } from "gsap";
import { CSSPlugin,  } from "gsap/CSSPlugin";
import svgPanZoom, { center } from "svg-pan-zoom";

export class Map {

  constructor ( el, data ) {
    this.el = el;
    this.cities = data;
    this.sortBy = this.el.getAttribute('data-sort') ?? 'transparent';
    this.resize = this.el.getAttribute('data-resize') ?? 'fit';
    this.type = this.el.getAttribute('data-type');
    this.svgMap = this.el.querySelector('.js-map-svg');
    this.ratingTooltip = this.el.querySelector('.js-map-raiting-tooltip');
    this.ratingMarker = this.el.querySelector('.js-map-raiting-marker');
    this.zoomInButton = this.el.querySelector('.js-map-button-zoom-in');
    this.zoomOutButton = this.el.querySelector('.js-map-button-zoom-out');
    this.tooltip = this.el.querySelector('.js-map-tooltip');
    this.points = new Array();
    this.activePoint = null;
    this.zoomMap = null;
    this.ratingRatio = 1;
    this.isTooltipHover = false;
    this.zoomLevel = 0;
    this.isMobile = false;
    this.isTooltipOpen = false;
    this.isMouseOver = false;
    this.tweens = new Array();

    this.text = {
      cat_1: this.el.getAttribute('data-cat1-text') ?? '',
      cat_2: this.el.getAttribute('data-cat2-text') ?? '',
      cat_3: this.el.getAttribute('data-cat3-text') ?? '',
    }
  }

  initDefault () {
    this.onResize();
    this.getPoints();
    this.initPoints();
    this.initZoomMap();
    this.initEvents();
  }

  reinit () {
    this.disablePoints();
    this.points = new Array();
    this.activePoint = null;
    this.getPoints();
    this.removeEvents();
    this.initEvents();
    this.initPoints();
    this.resetRatingBarValue(0);
  }

  getData ( data ) {
    this.cities = data
  }

  initEvents () {
    this.points.forEach( item => {
      $(item.el).on('mouseenter touchstart', e => this.onPointMouseenter(e, item.el));
      $(item.el).on('mouseleave', e => this.onPointMouseleave(item.el));
    });
    $(this.zoomInButton).on('click', e => this.zoomIn(e));
    $(this.zoomOutButton).on('click', e => this.zoomOut(e));
    this.tooltip.addEventListener('mouseenter', e => { this.isTooltipHover = true });
    this.tooltip.addEventListener('mouseleave', e => this.hideTooltip());
    this.svgMap.addEventListener('mousedown', e=> { document.querySelector('.svg-pan-zoom_viewport').style.transition = '' })
    this.svgMap.addEventListener('touchstart', e=> { document.querySelector('.svg-pan-zoom_viewport').style.transition = '' })
    window.addEventListener('resize', e => this.onResize());
    document.addEventListener('touchstart', e => this.onDocumentClick(e))
  }

  removeEvents () {
    this.points.forEach( item => {
      $(item.el).off()
    });
    $(this.zoomInButton).off();
    $(this.zoomOutButton).off();
  }

  onDocumentClick (e) {
    if ( !this.activePoint ) return;
    if ( !$('.js-map-tooltip').is(e.target) && $('.js-map-tooltip').has(e.target).length === 0 && !$(this.activePoint.el).is(e.target) && $(this.activePoint.el).has(e.target).length === 0 ) {
      if ( this.isTooltipOpen ) {
        this.onPointMouseleave(this.activePoint.el)
      }
    }
  }

  onResize () {
    this.detectMobile();
    this.resizeContainer();
    if ( this.zoomMap ) {
      this.ratingRatio = 1;
      this.zoomLevel = 0;
      this.zoomMap.resize();
      this.zoomMap.reset();
      this.zoomMap.center();
      this.setPointsDefaultSize();
    }
  }

  detectMobile () {
    window.innerWidth > 1023 ? this.isMobile = false : this.isMobile = true
  }

  resizeContainer () {
    if ( this.resize === 'default' ) return;
    if ( this.isMobile ) {
      this.el.style.width = '100%';
    } else {
      this.el.style.width = window.innerWidth - this.el.getBoundingClientRect().left + 'px'
    }
  }

  switchDataSort () {
    this.sortBy === 'transparent' ? this.sortBy = 'accountability' : this.sortBy = 'transparent'
    this.reinit();
  }

  zoomIn (e) {
    e.preventDefault();
    this.zoomMap.zoomIn();
    this.zoomLevel++;
    if ( this.zoomLevel > 7 ) {
      this.zoomLevel = 7;
      return;
    }
    this.ratingRatio = this.ratingRatio - 0.1;
    this.setPointsDefaultSize();
  }

  zoomOut (e) {
    e.preventDefault();
    this.zoomMap.zoomOut();
    this.zoomLevel--;
    
    if ( this.zoomLevel <= 0 ) {
      this.zoomLevel = 0;
      this.ratingRatio = 1;
      this.zoomMap.center();
      this.setPointsDefaultSize();
      return;
    }
    
    this.ratingRatio = this.ratingRatio + 0.1;
    this.setPointsDefaultSize();
  }

  onPointMouseenter (e, el) {
    this.closeAll()
    this.isMouseOver = true;
    const circle = el.querySelector('circle:last-child');
    const circleOverlay = el.querySelector('circle:first-child');
    this.setActivePoint(el);
    this.setRatingBarValue();
    this.hideTooltip();
    this.tween1 = TweenMax.to(circle, { duration: 0.4, transformOrigin: '50% 50%', scale: 1.6, ease: 'back(5).outIn' });
    this.tween2 = TweenMax.to(circleOverlay, { duration: 0.4, transformOrigin: '50% 50%', scale: 2.6, ease: 'back(5).outIn', onComplete: () => {
      if ( !this.isMouseOver ) return;
      this.type === 'categories' ? this.renderCategoriesTooltip() : this.renderTooltip()
      this.showTooltip();
      this.isTooltipOpen = true;
    } });
  }

  onPointMouseleave (el) {
    this.isMouseOver = false;
    if( this.tween1 && this.tween2 ) {
      this.tween1.kill()
      this.tween2.kill()
    }
    const circle = el.querySelector('circle:last-child');
    const circleOverlay = el.querySelector('circle:first-child');
    this.tweenOut1 = TweenMax.to(circle, { duration: 0.3, transformOrigin: '50% 50%', scale: 1 });
    this.tweenOut2 = TweenMax.to(circleOverlay, { duration: 0.3, transformOrigin: '50% 50%', scale: 1, onComplete: () => {
      if ( this.isTooltipHover ) return;
      this.hideTooltip();
      this.isTooltipOpen = false;
    }});
  }

  closeAll () {
    this.points.forEach( item => {
      this.onPointMouseleave(item.el)
    })
  }

  initZoomMap () {
    this.zoomMap = svgPanZoom(this.svgMap, {
      mouseWheelZoomEnabled: false,
      dblClickZoomEnabled: false,
      controlIconsEnabled: false,
      preventMouseEventsDefault: true,
      minZoom: 1,
      maxZoom: 10,
      zoomScaleSensitivity: 0.4,
      beforeZoom: () => {
        document.querySelector('.svg-pan-zoom_viewport').style.transition = 'transform 300ms linear'
      }
    })
  }

  getPoints () {
    this.cities.data.forEach( el => {
      const point = this.svgMap.getElementById(el.id);
      let rating = {};
      if ( !point ) return;
      if ( this.sortBy === 'transparent' ) {
        let accountValue = '-'
        if ( !el.rating.transparent || isNaN(el.rating.transparent.value) ) return;
        if ( el.rating.accountability && !isNaN(el.rating.accountability.value) ) {
          accountValue = el.rating.accountability.value
        }
        rating = {
          place: el.rating.transparent.place,
          main: { name: this.cities.locale.category.transparent.name, value: el.rating.transparent.value, level: el.rating.transparent.level, level_name: el.rating.transparent.level_name, disqualified: el.rating.transparent.disqualified },
          other: { name: this.cities.locale.category.accountability.name, value: accountValue }
        }
      } else {
        let transparentValue = '-'
        if ( !el.rating.accountability || isNaN(el.rating.accountability.value) ) return;
        if ( el.rating.transparent && !isNaN(el.rating.transparent.value) ) {
          transparentValue = el.rating.transparent.value
        }
        rating = {
          place: el.rating.accountability.place,
          main: { name: this.cities.locale.category.accountability.name, value: el.rating.accountability.value },
          other: { name: this.cities.locale.category.transparent.name, value: transparentValue, level: el.rating.transparent.level, level_name: el.rating.transparent.level_name, disqualified: el.rating.transparent.disqualified }
        }
      }
      this.points.push({
        el: point,
        name: el.name,
        url: el.url,
        rating: rating
      })
    })
  }

  setPointsDefaultSize () {
    this.points.forEach( item => {
      const circles = item.el.querySelectorAll('circle');
      circles.forEach( circle => {
        this.setPointSize(circle, item.rating.main, 0, 'ease');
      })
    })
  }

  initPoints () {
    this.points.forEach( item => {
      const circles = item.el.querySelectorAll('circle');

      if (this.type === 'categories') {
        this.setElementCategory(item.el, item.rating.main.level)
      } else {
        item.rating.main?.disqualified === true ? item.el.classList.add('disqualified') : item.el.classList.remove('disqualified')
      }


      circles.forEach( circle => {
        TweenMax.to( circle, {duration: 0, r: 0 } )
      })
    })
    this.startPointsAnimation();
  }

  setElementCategory (el, value, name = false) {
    el.classList.remove('cat_1')
    el.classList.remove('cat_2')
    el.classList.remove('cat_3')

    el.classList.add(`cat_${value}`)

    if (name) {
      el.textContent = name
    }
  }

  disablePoints () {
    this.tweens.forEach( el => {
      el.kill();
    })
    this.tweens = [];
    this.points.forEach( item => {
      const circles = item.el.querySelectorAll('circle');
      circles.forEach( circle => {
        TweenMax.to( circle, {duration: 0, r: 0 } )
      })
      item.el.classList.remove('active');
    })
  }

  setActivePoint ( el ) {
    this.activePoint = this.points.filter( item =>  {
      return item.el === el
    })
    this.activePoint = this.activePoint[0]
  }

  setPointSize (el, rating, delay, ease) {
    const easeFunction = ease || 'back(5).outIn';
    let value = rating.value
    if (this.type !== 'categories') {
      value = rating?.disqualified === true ? 1 : rating.value
    }
    const radius = (6 + value / 10) * this.ratingRatio;
    const strokeWidth = this.zoomLevel ? 2 - this.zoomLevel * 0.2 : 2
    const tween = TweenMax.to(el, {
      duration: 0.3,
      delay: delay,
      r: radius,
      strokeWidth: strokeWidth,
      ease: easeFunction
    })

    this.tweens.push(tween);
  }

  startPointsAnimation() {
    this.points.forEach( (item, index) => {
      item.el.classList.add('active');
      const circles = item.el.querySelectorAll('circle');
      circles.forEach( circle => {
        this.setPointSize(circle, item.rating.main, index * 0.1)
      })
    })
  }

  setRatingBarValue () {
    if (!this.ratingMarker) return;
    const textNode = this.ratingTooltip.querySelector('span')
    const ratingValue  = this.activePoint.rating.main?.disqualified === true ? 0 : this.activePoint.rating.main.value;
    textNode.innerHTML = ratingValue;
    this.ratingMarker.style.transform = 'translate3d(0, ' + -ratingValue + '%, 0)'
  }

  resetRatingBarValue () {
    if (!this.ratingTooltip) return;
    const textNode = this.ratingTooltip.querySelector('span')
    textNode.innerHTML = 0;
    TweenMax.to(this.ratingMarker, { duration: 0.3, bottom: 0 + '%' });
  }

  renderTooltip ( data ) {
    const nameEl = this.tooltip.querySelector('.js-tooltip-name');
    const placeEl = this.tooltip.querySelector('.js-tooltip-place');
    const mainRatingNameEl = this.tooltip.querySelector('.js-tooltip-main-rating-name');
    const mainRatingValueEl = this.tooltip.querySelector('.js-tooltip-main-rating-value');
    const otherRatingNameEl = this.tooltip.querySelector('.js-tooltip-other-rating-name');
    const otherRatingValueEl = this.tooltip.querySelector('.js-tooltip-other-rating-value');
    const buttonEl = this.tooltip.querySelector('.js-tooltip-button');

    nameEl.innerHTML = this.activePoint.name;
    nameEl.setAttribute('href', this.activePoint.url)
    placeEl.innerHTML = this.activePoint.rating.main?.disqualified === true ? '-' : this.activePoint.rating.place;
    mainRatingNameEl.innerHTML = this.activePoint.rating.main.name;
    mainRatingValueEl.innerHTML = this.activePoint.rating.main?.disqualified === true ? '-' : this.activePoint.rating.main.value;
    otherRatingNameEl.innerHTML = this.activePoint.rating.other.name;
    otherRatingValueEl.innerHTML = this.activePoint.rating.other.value;
    buttonEl.setAttribute('href', this.activePoint.url);
  }
  
  renderCategoriesTooltip ( data ) {
    const nameEl = this.tooltip.querySelector('.js-tooltip-name');
    const mainRatingNameEl = this.tooltip.querySelector('.js-tooltip-main-rating-name');

    nameEl.textContent = this.activePoint.name;
    nameEl.setAttribute('href', this.activePoint.url)

    this.setElementCategory(mainRatingNameEl, this.activePoint.rating.main.level, this.activePoint.rating.main.level_name)
  }

  showTooltip () {
    const el = this.activePoint.el,
    centerX = el.getBoundingClientRect().left - this.tooltip.offsetWidth/2 + el.getBoundingClientRect().width/2,
    centerY = el.getBoundingClientRect().top,
    tooltipPosX = centerX,
    tooltipPosY = centerY - this.tooltip.offsetHeight;
    
    this.tooltip.style.left = tooltipPosX + 'px';
    this.tooltip.style.top = tooltipPosY - 8 + 'px';
    this.tooltip.classList.add('active')
  }

  hideTooltip () {
    this.isTooltipHover = false;
    this.tooltip.classList.remove('active')
  }

}

window.addEventListener('DOMContentLoaded', e => {
  const el = document.querySelector('.js-map');
  if ( el ) {
    window.Map = new Map( el );
  }
})